import WithoutHeaderLayout from "./without-header.layout";
export default WithoutHeaderLayout;